/**
 * Endpoints de Turnos en vivo.
 *
 * Es una vista de monitoreo: sólo lectura, sin acciones sobre el turno.
 */

import { apiClient } from '@/lib/http/api-client';

import type { TurnosEnVivo } from './turnos.types';

export const turnosKeys = {
  all: ['turnos'] as const,
  enVivo: ['turnos', 'en-vivo'] as const,
};

export const turnosApi = {
  /** Turnos abiertos con su detalle y el consolidado general. */
  enVivo: (signal?: AbortSignal): Promise<TurnosEnVivo> =>
    apiClient.get<TurnosEnVivo>('/api/turnos_en_vivo', { signal }),
} as const;
